<mbs-modal
  [showOkButton]="false"
  [title]="'storages:addStorageAccountWizard.inputCredentialsStep.minimumRequiredPermissions' | i18next: { format: 'title' }">
  <ng-container modal-body>
    @if (loading()) {
      <mbs-loader></mbs-loader>
    } @else {
      <pre class="json-field">{{ requiredPermissions() }}</pre>
    }
  </ng-container>
</mbs-modal>
